export default __webpack_public_path__ + "static/media/userexpert.c12559b4.svg";